import { Col, Row, Space, Typography } from "antd";
import { steps } from "./data";

const HowItWorksSection = () => {
  return (
    <section className="how-it-works-section section-margin-top container">
      <Row gutter={[20, 20]}>
        <Col xs={24} md={8}>
          <Typography.Title level={2} className="mt-0">
            How it works here at HSTC-Engineering
          </Typography.Title>
          <Typography.Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
            pulvinar odio in magna condimentum, et euismod ante rhoncus.
            Maecenas elementum metus quis dolor convallis convallis.
          </Typography.Paragraph>
        </Col>
        <Col xs={24} md={16}>
          <Row gutter={[20, 20]}>
            {steps.map((step, index) => (
              <Col xs={24} sm={12} key={index}>
                <Step
                  number={index + 1}
                  title={step.title}
                  description={step.desc}
                />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default HowItWorksSection;

const Step = ({ number, title, description }) => (
  <div className={`hiw-step ${number === 1 ? "first" : ""}`}>
    <Space align="top">
      <Typography.Title
        level={4}
        className="text-primary-color white-space-nowrap"
      >{`0${number}`}</Typography.Title>
      <Typography.Title level={4}>{title}</Typography.Title>
    </Space>
    <Typography.Paragraph>{description}</Typography.Paragraph>
  </div>
);
